<template>
	<div v-loading="loading" :style="{
		minHeight: equipment == 'pc'?'500px':'100vh'
	}" style="user-select:text;width: 100%;background-color: #fff;margin-top: 20px;font-size: 14px;">
		<el-form label-position="top" size="16" style="width: 100%;" :model="form" :rules="rules" ref="ruleForm"
			label-width="100px" class="demo-ruleForm">
			<div>
				<div style="display: flex;align-items: center;width: 100%;margin-top: 10px;">
					<el-form-item prop="name" style="width: 50%;" :label="$t('h.name')">
						<el-input v-model="form.name" :placeholder="$t('h.name')"></el-input>
					</el-form-item>
					<!-- 	<el-form-item prop="email" style="width: 50%;margin-left: 10px;" :label="$t('h.email')">
					<el-input v-model="form.email" :placeholder="$t('h.email')"></el-input>
				</el-form-item> -->
					<el-form-item prop="address1" style="" style="width: 50%;margin-left: 10px;"
						:label="$t('h.address1')">
						<el-input v-model="form.address1" :placeholder="$t('h.address1')"></el-input>
					</el-form-item>
				</div>

				<div style="display: flex;align-items: center;width: 100%;">
					<el-form-item prop="address2" style="width: 50%;" :label="$t('h.address2')">
						<el-input v-model="form.address2" :placeholder="$t('h.address2')"></el-input>
					</el-form-item>
					<el-form-item prop="emailCode" style="margin-left: 10px;width: 50%;" :label="$t('h.emailCode')">
						<el-input v-model="form.emailCode" :placeholder="$t('h.emailCode')"></el-input>
					</el-form-item>
				</div>
				<div style="display: flex;align-items: center;width: 100%;">
					<el-form-item prop="phone" style="width: 50%;" :label="$t('h.phone')">
						<el-input v-model="form.phone" :placeholder="$t('h.phone')"></el-input>
					</el-form-item>
					<el-form-item prop="city" style="margin-left: 10px;width: 50%;" :label="$t('h.city')">
						<el-input v-model="form.city" :placeholder="$t('h.city')"></el-input>
					</el-form-item>
				</div>
				<div style="display: flex;align-items: center;width: 100%;">
					<el-form-item prop="country" style="width: 50%;" :label="$t('h.country')">
						<el-select style="width: 100%;" @change="changeCountries" v-model="form.country"
							:placeholder="$t('h.country')">
							<el-option v-for="item in localPageData.countries" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="province" style="width: 50%;margin-left: 10px;" :label="$t('h.province')">
						<el-select style="width: 100%;" loading-text="Loading..." no-data-text="Empty"
							:loading="selectLoading" @change="changeZones" v-model="form.province" :placeholder="$t('h.province')">
							<el-option v-for="item in localPageData.zones" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<el-button class="btn-ok" style="background-color: #000;border: solid 1px #000;margin-top: 20px;width: 40%;"
			type="primary" @click="submit">{{$t('h.confirm')}}</el-button>
	</div>
</template>

<script>
	import {
		getaccountGetAddresses,
		getCheckoutUpdateAddresses,
		getZones,
		getCheckoutAddresses
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
		},
		data() {
			return {
				localPageData: {

				},
				loading: false,
				selectLoading: false,
				form: {
					id: -1,
					sendWay: '',
					payWay: '',
					name: '',
					// email: '',
					address1: '',
					address2: '',
					emailCode: '',
					phone: '',
					city: '',
					country: '',
					province: '',
					comment: "",
					checkCode: "",
					countryName:"",
					zonesName:""
				},
				rules: {
					// email: [{
					// 		required: true,
					// 		message: this.$t('h.errorEmail'),

					// 		trigger: ['blur', 'change']
					// 	},
					// 	{
					// 		validator: this.checkEmail,
					// 		trigger: 'blur'
					// 	}
					// ],
					name: [{
						required: true,
						message: this.$t('h.nameError'),
						trigger: ['blur', 'change']
					}, ],
					address1: [{
						required: true,
						message: this.$t('h.address1Error'),
						trigger: ['blur', 'change']
					}, ],
					country: [{
						required: true,
						message: this.$t('h.countryError'),
						trigger: ['blur', 'change']
					}, ],
					province: [{
						required: true,
						message: this.$t('h.provinceError'),
						trigger: ['blur', 'change']
					}, ],
				}
			}

		},
		async mounted() {
			try {
				this.loading = true
				let data = await getaccountGetAddresses()
				console.log('datadata', data)
				if (data.data.data.addresses.name) {
					this.form.name = data.data.data.addresses.name
					this.form.address1 = data.data.data.addresses.address_1
					this.form.address2 = data.data.data.addresses.address_2
					this.form.city = data.data.data.addresses.city
					this.form.country = data.data.data.addresses.country_id
					this.form.id = data.data.data.addresses.id
					this.form.emailCode = data.data.data.addresses.zipcode
					this.form.phone = data.data.data.addresses.phone
					let zones = await getZones({
						id: data.data.data.addresses.country_id
					})
					this.form.province = data.data.data.addresses.zone_id
					this.localPageData.zones = zones.data.data.zones
					this.form.countryName = data.data.data.addresses.country
					this.form.zonesName = data.data.data.addresses.zone
				}
				this.localPageData.countries = data.data.data.countries

				this.loading = false
			} catch (e) {
				this.loading = false
			}
		},
		methods: {
			submit() {
				this.$refs['ruleForm'].validate(async (valid) => {
					if (valid) {
						try {
							this.loading = true
							// await getaccountUpdatepassword(this.form)
							if (this.form.id) {
								await getCheckoutUpdateAddresses({
									id: this.form.id,
									address_1: this.form.address1,
									address_2: this.form.address2,
									city: this.form.city,
									country_id: this.form.country,
									default: true,
									name: this.form.name,
									phone: this.form.phone,
									zipcode: this.form.emailCode,
									zone_id: this.form.province,
									country:this.form.countryName,
									zone: this.form.zonesName

								})
								this.$message.success('success')
							} else {
								await getCheckoutAddresses({
									address_1: this.form.address1,
									address_2: this.form.address2,
									city: this.form.city,
									country_id: this.form.country,
									default: true,
									name: this.form.name,
									phone: this.form.phone,
									zipcode: this.form.emailCode,
									zone_id: this.form.province,
									country:this.form.countryName,
									zone: this.form.zonesName
								})
							}

							this.loading = false
						} catch (e) {
							this.loading = false
						}
					} else {
						return false;
					}
				});
			},
			change() {

			},
			changeZones(e) {
				console.log('e', e)
				this.localPageData.zones.forEach(item => {
					if (item.id == e) {
						this.form.zonesName = item.name
					}
				})
				console.log('this.form',this.form)
				
			},
			async changeCountries(e) {
				console.log('e', e)
				this.localPageData.countries.forEach(item => {
					if (item.id == e) {
						this.form.countryName = item.name
					}
				})
				console.log('this.form',this.form)

				this.selectLoading = true
				this.localPageData.zones = []
				this.form.province = ''
				console.log('changeCountries', e)
				let zones = await getZones({
					id: e
				})
				this.selectLoading = false
				this.localPageData.zones = zones.data.data.zones
				this.$forceUpdate()
				console.log('zoneszoneszones', this.localPageData.zones)
			}

		}
	}
</script>

<style>
</style>